import axios from 'axios'
import { functionsEndpoint } from './firebase'

// Chave de storage separada da chave 'scolados-fb' usada pelo login normal
// (Firebase Auth) — esse é um login de admin hardcoded, independente.
const STORAGE_KEY = 'scolados-admin-token'

export async function adminLogin(username, password) {
  const { data } = await axios.post(`${functionsEndpoint}/admin/login`, { username, password })
  localStorage.setItem(STORAGE_KEY, data.token)
}

export function getAdminToken() {
  return localStorage.getItem(STORAGE_KEY)
}

export function isAdminAuthenticated() {
  return !!getAdminToken()
}

export function adminLogout() {
  localStorage.removeItem(STORAGE_KEY)
}
